import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function GlobalFarmPage() {
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("all");
  const [selectedCategory, setSelectedCategory] = useState("all");

  // 1. 기존 숙박/마을 중심 데이터 스토어
  const farmData = [
    {
      id: "gapa",
      targetPath: "/global/korea/gapa-village",
      name: "가파 마을",
      location: "충청남도 청양군",
      tags: ["🌾 농촌 활동", "🏡 가족친화", "✂️ 농산물 수확"],
      imgUrl:
        "https://tour.chungnam.go.kr/thumbnail/trsrcn/920_TRSRCN_202501060339029310.jpg",
      desc: "청양 특산물로 만드는 웰빙 구기자 체험과 산책로 따라 펼쳐지는 사계절 꽃밭이 매력적인 힐링 마을.",
      rating: "4.8"
    },
    {
      id: "onui",
      targetPath: "/global/korea/onui-village",
      name: "오누이 마을",
      location: "충청남도 홍성군",
      tags: ["🌾 농촌 활동", "🛌 숙박연계", "🦀 제철수확"],
      imgUrl:
        "https://cdn.welfarehello.com/naver-blog/production/hsgstory/2023-09/223214518948/hsgstory_223214518948_1.jpg?f=webp&q=80&w=800",
      desc: "청년 농부들로부터 시작해 친환경 농업, 공동체 문화 활동, 도농 교류를 실천하며 누구에게나 열려 있는 농촌 공동체 거점 공간.",
      rating: "4.7"
    },
    {
      id: "yongggum",
      targetPath: "/global/korea/yongggum-village",
      name: "용꿈 꾸는 마을 (Yongggum Village)",
      location: "충청남도 청양군",
      tags: ["🚜 농촌활동", "🛌 팜스테이", "🪵 캠프파이어"],
      imgUrl:
        "https://cdn.traveldaily.co.kr/news/photo/201808/16296_22398_3718.jpg",
      desc: "칠갑산 자락의 청정 자연 속에서 즐기는 이색 헬기장 체험과 전통 떡메치기.",
      rating: "4.9"
    }
  ];

  // 🌟 [신규 추가] 하단에 노출할 베스트 액티비티/체험 전용 데이터 스토어
  const experienceData = [
    {
      id: "exp-rice",
      targetPath: "/global", // 추후 개별 서브코스로 연결 가능
      name: "전통 방식 인절미 떡메치기 체험",
      provider: "용꿈꾸는마을",
      location: "충청남도 청양군",
      price: "15,000원 + ",
      tags: ["🍡 전통간식", "🎓 교육적", "👪 아동추천"],
      imgUrl:
        "https://img0.yna.co.kr/photo/yna/YH/2024/10/10/PYH2024101011940001300_P4.jpg",
      desc: "커다란 나무 떡메를 직접 치며 갓 쪄낸 찹쌀을 쫄깃 고소한 인절미로 만드는 체험 활동."
    },
    {
      id: "exp-apple",
      targetPath: "/global",
      name: "가을 아삭아삭 사과 수확 및 베이킹",
      provider: "은하수 과수원",
      location: "충청북도 충주시",
      price: "20,000원 +",
      tags: ["🍎 제철수확", "🍰 쿠킹클래스"],
      imgUrl: "https://cdn.hkbs.co.kr/news/photo/201910/538118_294791_924.jpg",
      desc: "맑은 가을 햇살 아래서 새빨간 사과를 직접 따고, 오븐으로 달콤한 타르트를 구워보는 클래스."
    },
    {
      id: "exp-pottery",
      targetPath: "/global",
      name: "달빛 아래 옹기 빚기 워크숍",
      provider: "도담 도예방",
      location: "전라남도 강진군",
      price: "35,000원 + ",
      tags: ["🏺 예술공방", "✨ 감성체험", "🪵 가마투어"],
      imgUrl:
        "https://mblogthumb-phinf.pstatic.net/MjAxOTAyMDZfOTIg/MDAxNTQ5NDI0MTk2NjM2.RzlGaRMLllx7XtGiNu_FT6ldR1lMvlhFjCAQJ9j3D6Ig.bwJr61rh4FdI8OapmUlBuyYdU3ShobQroQ_KOdvez7Qg.JPEG.free_web/DSC_3730_%EB%B3%B5%EC%82%AC.jpg?type=w800",
      desc: "고즈넉한 한옥 공방에서 물레를 차며 나만의 전통 식기와 화분을 빚어보는 장인 멘토링 코스."
    }
  ];

  const handleCardClick = (targetPath) => {
    navigate(targetPath);
  };

  return (
    <div style={styles.pageContainer}>
      {/* 1. HERO BANNER SECTION */}
      <section style={styles.heroSection}>
        <div style={styles.heroOverlay} />
        <div style={styles.heroContent}>
          <span style={styles.heroSubTag}>Discover your next escape</span>
          <h1 style={styles.heroMainTitle}>
            도시의 속도에서 벗어나, 자연의 리듬으로.
            <br />
            팜시티가 삶의 쉼표가 되어드립니다.
          </h1>
          <p style={styles.heroDesc}>
            바쁜 일상 너머, 현지 농가가 정성으로 차려낸 진짜 농촌의 여유를
            만나보세요.
          </p>

          <div style={styles.searchPanel}>
            <div style={styles.searchGrid}>
              <div style={styles.searchFieldItem}>
                <label style={styles.fieldLabel}>지역 검색 (Region)</label>
                <select
                  style={styles.fieldSelect}
                  value={selectedRegion}
                  onChange={(e) => setSelectedRegion(e.target.value)}
                >
                  <option value="all">대한민국 전지역</option>
                  <option value="gyeonggido">경기도</option>
                  <option value="chungchung">충청도</option>
                  <option value="jeonla">전라도</option>
                  <option value="gyeongsang">경상도</option>
                  <option value="gangwon">강원도</option>
                </select>
              </div>
              <div style={styles.searchFieldSplitter} />
              <div style={styles.searchFieldItem}>
                <label style={styles.fieldLabel}>체험 테마 (Theme)</label>
                <select
                  style={styles.fieldSelect}
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                >
                  <option value="all">모든 활동 카테고리</option>
                  <option value="activity">🚜 액티비티 / 체험</option>
                  <option value="stay">🛌 팜스테이 / 숙박</option>
                  <option value="workshop">🎨 워크숍</option>
                  <option value="bonfire">🔥 본파이어</option>
                  <option value="education">🎓 교육</option>
                  <option value="food">🍱 지역 특산물</option>
                </select>
              </div>
              <div style={styles.searchFieldSplitter} />
              <div style={styles.searchFieldItemCustom}>
                <label style={styles.fieldLabel}>마을 이름</label>
                <input
                  type="text"
                  placeholder="예: 용꿈꾸는마을"
                  style={styles.fieldInput}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
            <button style={styles.searchSubmitBtn}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* 2. BROWSE BY CATEGORIES */}
      <section style={styles.sectionWrapper}>
        <h2 style={styles.sectionTitle}>체험 카테고리</h2>
        <div style={styles.categoryCircleGrid}>
          {[
            { icon: "🚜", title: "체험", count: "12곳" },
            { icon: "🛌", title: "팜스테이", count: "8곳" },
            { icon: "🌾", title: "워크샵", count: "15곳" },
            { icon: "🪵", title: "본파이어", count: "6곳" },
            { icon: "🎓", title: "교육", count: "9곳" },
            { icon: "🍱", title: "지역 특산물", count: "11곳" }
          ].map((item, idx) => (
            <div key={idx} style={styles.categoryCircleItem}>
              <div style={styles.circleIconBox}>{item.icon}</div>
              <div style={styles.circleTitle}>{item.title}</div>
              <div style={styles.circleCount}>{item.count}</div>
            </div>
          ))}
        </div>
      </section>

      {/* 3. STREAM A: FEATURED FARMSTAYS SECTION */}
      <section style={styles.sectionWrapper}>
        <div style={styles.sectionHeaderRow}>
          <div>
            <h2 style={styles.sectionTitle}>농촌 팜스테이</h2>
            <p style={styles.sectionSubTitle}>
              팜시티가 검증한 가장 매력적인 한국의 로컬 체험 마을을 소개합니다.
            </p>
          </div>
          <button style={styles.viewAllBtn}>View all farms →</button>
        </div>

        <div style={styles.cardStreamGrid}>
          {farmData.map((farm) => (
            <div
              key={farm.id}
              style={styles.farmCard}
              onClick={() => handleCardClick(farm.targetPath)}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "translateY(-6px)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "translateY(0)")
              }
            >
              <div
                style={{
                  ...styles.cardImgHeader,
                  backgroundImage: `url(${farm.imgUrl})`
                }}
              >
                <div style={styles.cardRatingBadge}>★ {farm.rating}</div>
              </div>
              <div style={styles.cardBodyContent}>
                <span style={styles.cardLocationLabel}>{farm.location}</span>
                <h3 style={styles.cardFarmName}>{farm.name}</h3>
                <p style={styles.cardFarmDesc}>{farm.desc}</p>
                <div style={styles.cardBadgeRow}>
                  {farm.tags.map((tag, i) => (
                    <span key={i} style={styles.cardMiniBadge}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 5. PROMOTION BANNER SECTION */}
      <section
        style={styles.sectionWrapper}
        style={{ marginTop: "80px", ...styles.sectionWrapper }}
      >
        <div style={styles.promoBannerBox}>
          <div style={styles.promoLeftContent}>
            <h3>호스트로 참여하여 마을을 알리세요</h3>
            <p>
              전 세계의 여행객 및 디지털 노마드들에게 우리 전통 마을만의 가치와
              이색적인 자연 체험 프로그램, 편안한 숙박 공간을 공유하고 로컬
              비즈니스를 확장할 수 있습니다.
            </p>
            <button style={styles.promoBtn}>파트너십 문의</button>
          </div>
          <div style={styles.promoRightGraphic}>
            <div style={styles.graphicCircle1} />
            <div style={styles.graphicCircle2} />
            <span style={styles.graphicEmoji}>👩‍🌾🌾</span>
          </div>
        </div>
      </section>

      {/* 🌟 4. [신규 추가] STREAM B: BEST SEASONAL EXPERIENCES SECTION */}
      <section style={styles.sectionWrapper}>
        <div style={styles.sectionHeaderRow}>
          <div>
            <h2 style={styles.sectionTitle}>체험 프로그램</h2>
            <p style={styles.sectionSubTitle}>
              도시를 떠나 오감을 만족 시킬 농촌 워크숍 프로그램을 만나보세요.
            </p>
          </div>
          <button style={styles.viewAllBtn}>Explore all activities →</button>
        </div>

        <div style={styles.cardStreamGrid}>
          {experienceData.map((exp) => (
            <div
              key={exp.id}
              style={styles.farmCard}
              onClick={() => handleCardClick(exp.targetPath)}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "translateY(-6px)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "translateY(0)")
              }
            >
              {/* 이미지 헤더 홀더 */}
              <div
                style={{
                  ...styles.cardImgHeader,
                  backgroundImage: `url(${exp.imgUrl})`
                }}
              >
                <div style={styles.cardPriceTag}>{exp.price}</div>
              </div>
              {/* 텍스트 메타 구역 */}
              <div style={styles.cardBodyContent}>
                <span style={styles.cardLocationLabel}>
                  {exp.location} • {exp.provider}
                </span>
                <h3 style={styles.cardFarmName}>{exp.name}</h3>
                <p style={styles.cardFarmDesc}>{exp.desc}</p>
                <div style={styles.cardBadgeRow}>
                  {exp.tags.map((tag, i) => (
                    <span key={i} style={styles.cardMiniBadge}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

const styles = {
  pageContainer: {
    fontFamily: "aria, sans-serif",
    width: "100%",
    backgroundColor: "#fcfcf9",
    color: "#2d3748",
    paddingBottom: "8px",
    paddingBottom: "80px"
  },
  heroSection: {
    width: "100%",
    minHeight: "55vh",
    background:
      'linear-gradient(rgba(0, 77, 4, 0.75), rgba(0, 0, 0, 0.60)), url("https://images.unsplash.com/photo-1444858291040-58f756a3bdd6?q=80&w=1678&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D") center/cover no-repeat',
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px",
    textAlign: "center"
  },
  heroOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.1)",
    zIndex: 1
  },
  heroContent: {
    maxWidth: "850px",
    width: "100%",
    zIndex: 2,
    color: "#ffffff"
  },
  heroSubTag: {
    fontSize: "14px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "1.5px",
    color: "#a8e6cf",
    display: "inline-block",
    marginBottom: "16px"
  },
  heroMainTitle: {
    fontSize: "42px",
    fontWeight: "800",
    lineHeight: "1.3",
    marginBottom: "20px",
    letterSpacing: "-1px"
  },
  heroDesc: {
    fontSize: "17px",
    opacity: "0.85",
    marginBottom: "40px",
    fontWeight: "400"
  },
  searchPanel: {
    backgroundColor: "#ffffff",
    borderRadius: "100px",
    padding: "10px 14px 10px 32px",
    display: "flex",
    alignItems: "center",
    boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
    maxWidth: "800px",
    margin: "0 auto",
    textAlign: "left"
  },
  searchGrid: { display: "flex", flex: 1, alignItems: "center" },
  searchFieldItem: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    paddingRight: "12px",
    paddingLeft: "5px"
  },
  searchFieldItemCustom: {
    flex: "1.2",
    display: "flex",
    flexDirection: "column",
    paddingLeft: "12px"
  },
  searchFieldSplitter: {
    width: "1px",
    height: "32px",
    backgroundColor: "#e2e8f0"
  },
  fieldLabel: {
    fontSize: "11px",
    fontWeight: "700",
    color: "#a0aec0",
    textTransform: "uppercase",
    marginBottom: "2px"
  },
  fieldSelect: {
    border: "none",
    outline: "none",
    fontSize: "14px",
    fontWeight: "600",
    color: "#2d3748",
    backgroundColor: "transparent",
    cursor: "pointer",
    width: "100%"
  },
  fieldInput: {
    border: "none",
    outline: "none",
    fontSize: "14px",
    color: "#2d3748",
    width: "100%",
    fontWeight: "500"
  },
  searchSubmitBtn: {
    backgroundColor: "#1a4331",
    color: "#ffffff",
    border: "none",
    outline: "none",
    width: "52px",
    height: "52px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "transform 0.2s ease"
  },
  sectionWrapper: {
    maxWidth: "1200px",
    margin: "60px auto 0 auto",
    padding: "0 40px"
  },
  sectionHeaderRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: "28px"
  },
  sectionTitle: {
    fontSize: "26px",
    fontWeight: "800",
    color: "#1a202c",
    letterSpacing: "-0.5px",
    marginBottom: "6px"
  },
  sectionSubTitle: { fontSize: "15px", color: "#718096" },
  viewAllBtn: {
    backgroundColor: "transparent",
    border: "none",
    color: "#1a4331",
    fontWeight: "700",
    fontSize: "15px",
    cursor: "pointer",
    paddingBottom: "4px",
    borderBottom: "2px solid #1a4331"
  },
  categoryCircleGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
    gap: "20px",
    marginTop: "24px"
  },
  categoryCircleItem: {
    backgroundColor: "#ffffff",
    border: "1px solid #edf2f7",
    borderRadius: "16px",
    padding: "24px 16px",
    textAlign: "center",
    cursor: "pointer",
    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.02)",
    transition: "transform 0.2s, box-shadow 0.2s"
  },
  circleIconBox: { fontSize: "32px", marginBottom: "12px" },
  circleTitle: { fontSize: "15px", fontWeight: "700", color: "#2d3748" },
  circleCount: { fontSize: "12px", color: "#a0aec0", marginTop: "4px" },
  cardStreamGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
    gap: "30px"
  },
  farmCard: {
    backgroundColor: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    transition:
      "transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.25s ease"
  },
  cardImgHeader: {
    width: "100%",
    height: "210px",
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundColor: "#e2e8f0"
  },
  cardRatingBadge: {
    position: "absolute",
    top: "16px",
    right: "16px",
    backgroundColor: "#ffffff",
    color: "#1a202c",
    padding: "4px 10px",
    borderRadius: "30px",
    fontSize: "12px",
    fontWeight: "700",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
  },
  // 🌟 [신규 추가] 체험 카드의 우측 가격 배지 레이아웃 스타일
  cardPriceTag: {
    position: "absolute",
    bottom: "12px",
    right: "16px",
    backgroundColor: "#1a4331",
    color: "#ffffff",
    padding: "4px 12px",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: "700",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
  },
  cardBodyContent: {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    flex: "1"
  },
  cardLocationLabel: {
    fontSize: "12px",
    fontWeight: "700",
    color: "#a0aec0",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: "6px"
  },
  cardFarmName: {
    fontSize: "19px",
    fontWeight: "800",
    color: "#1a202c",
    marginBottom: "10px"
  },
  cardFarmDesc: {
    fontSize: "14px",
    color: "#4a5568",
    lineHeight: "1.5",
    marginBottom: "20px",
    flex: "1"
  },
  cardBadgeRow: { display: "flex", flexWrap: "wrap", gap: "6px" },
  cardMiniBadge: {
    backgroundColor: "#f7fafc",
    border: "1px solid #e2e8f0",
    color: "#4a5568",
    padding: "4px 10px",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "600"
  },
  promoBannerBox: {
    background: "linear-gradient(135deg, #1a4331 0%, #2d5a43 100%)",
    borderRadius: "20px",
    padding: "48px",
    color: "#ffffff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    overflow: "hidden",
    position: "relative",
    marginTop: "40px"
  },
  promoLeftContent: { flex: "1.5", zIndex: 2 },
  promoBtn: {
    backgroundColor: "#ffffff",
    color: "#1a4331",
    border: "none",
    outline: "none",
    padding: "14px 28px",
    borderRadius: "10px",
    fontWeight: "700",
    fontSize: "15px",
    marginTop: "24px",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
  },
  promoRightGraphic: {
    flex: "1",
    position: "relative",
    height: "180px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  graphicEmoji: { fontSize: "80px", zIndex: 2 },
  graphicCircle1: {
    position: "absolute",
    width: "200px",
    height: "200px",
    backgroundColor: "rgba(255,255,255,0.05)",
    borderRadius: "50%",
    top: "-20px"
  },
  graphicCircle2: {
    position: "absolute",
    width: "300px",
    height: "300px",
    backgroundColor: "rgba(255,255,255,0.03)",
    borderRadius: "50%",
    bottom: "-50px",
    right: "-30px"
  }
};
